import { render, staticRenderFns } from "./BaseDebugOverview.vue?vue&type=template&id=861ec162"
import script from "./BaseDebugOverview.vue?vue&type=script&lang=js"
export * from "./BaseDebugOverview.vue?vue&type=script&lang=js"
import style0 from "./BaseDebugOverview.vue?vue&type=style&index=0&id=861ec162&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports